<template>
  <div class="terms-overlay" @click.self="$emit('close')">
    <div class="terms-card">
      <div class="terms-header">
        <h2>{{ t('termsTitle') }}</h2>
        <button class="close-btn" @click="$emit('close')">&#10005;</button>
      </div>

      <div class="terms-meta">
        {{ t('termsVersionLabel') }} {{ termsVersion }} &middot; {{ termsDate }}
      </div>

      <div class="terms-body">
        <p v-for="(para, i) in paragraphs" :key="i">{{ para }}</p>
      </div>

      <div class="terms-actions">
        <button @click="$emit('close')">{{ t('close') }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import { useI18n } from "../i18n.js"
import { TERMS_VERSION, TERMS_DATE } from "../terms.js"

export default {
  name: "ChatTerms",

  emits: ["close"],

  setup() {
    const { t } = useI18n()
    return { t }
  },

  computed: {
    termsVersion() { return TERMS_VERSION },
    termsDate() { return TERMS_DATE },
    paragraphs() {
      return this.t('termsBody').split(/\n\n+/).map(s => s.trim()).filter(Boolean)
    }
  }
}
</script>

<style scoped>
.terms-overlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 200;
}

.terms-card {
  width: min(640px, calc(100vw - 32px));
  background: white;
  padding: 24px;
  border-radius: 12px;
  max-height: calc(100dvh - 32px);
  display: flex;
  flex-direction: column;
  gap: 12px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

.terms-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.terms-header h2 {
  margin: 0;
  font-size: 18px;
}

.close-btn {
  border: none;
  background: none;
  font-size: 20px;
  cursor: pointer;
  color: #666;
}

.close-btn:hover {
  color: #000;
}

.terms-meta {
  font-size: 12px;
  color: #6b7280;
}

.terms-body {
  overflow-y: auto;
  font-size: 14px;
  line-height: 1.5;
  color: #1f2937;
  padding-right: 4px;
}

.terms-body p {
  margin: 0 0 10px 0;
  white-space: pre-wrap;
}

.terms-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  border-top: 1px solid #e4e8ee;
  padding-top: 12px;
}

.terms-actions button {
  padding: 10px 16px;
  background: #2563eb;
  color: white;
  border: none;
  border-radius: 8px;
  font-family: inherit;
  font-size: 14px;
  cursor: pointer;
}
</style>